import { api, ApiRequestError } from "./api.ts";
import { ensureTermsRecorded } from "./terms.ts";

/**
 * Beta-gate check that BLOCKS render (§5.11): protected routes wait in the
 * router's beforeLoad until /v1/me has succeeded once, so an ungated visitor
 * is redirected before any screen paints — never after. Memoized: the network
 * round-trip happens once per app load; navigations stay instant.
 */
let passed = false;
let inflight: Promise<void> | null = null;

export async function ensureGated(): Promise<void> {
  if (passed) return;
  inflight ??= api.me().then(async () => {
    passed = true;
    // D-38: the terms acceptance goes on record once the account is in; a
    // failure here is never a reason to keep someone out of their shelf
    await ensureTermsRecorded().catch(() => {});
  });
  try {
    await inflight;
  } catch (e) {
    inflight = null; // retry on next navigation (e.g. after entering an invite)
    // Offline is invisible by design: without a network verdict, let the
    // cached app render — the server still enforces the gate on every call.
    if (e instanceof ApiRequestError && e.status > 0) throw e;
  }
}
